
export default function SQLs_Joins() {
  return (
    <div>
      <h1>SQL Joins</h1>
      <p>Content for SQL Joins will go here.</p>
    </div>
  );
}
